import React from "react";
import "./styles/hero.css";
const Hero = () => {
  return (
    <>
      <div className="container hero-container">
        <div className="hero-left-heading">
          <h1>Reinventing App Monetization</h1>
        </div>
        <div className="hero-right">
          <div className="right-hero-line"></div>
          <p>
            Real Opinion is developed by GamingAce Technologies Pvt. Ltd. with a
            mission to make app monetization smarter, faster, and more
            user-focused. We identified the gaps in survey walls — low
            engagement, irrelevant targeting, and poor payouts — and built a
            solution that works for both publishers and users. With strong
            industry partnerships and a product-first mindset, we are reshaping
            how publishers think about revenue.
          </p>
        </div>
      </div>
      <div className="hero-image">
        <img src="images/abtpub.png" alt="About Us" />
      </div>
    </>
  );
};

export default Hero;
